import { createI18n } from 'vue-i18n'
import en from '@/i18n/locale/en.json'
import ru from '@/i18n/locale/ru.json'

const AVAILABLE_LOCALES = ['en', 'ru']

const detectLocale = () => {
  const browserLocale = (navigator.language || 'ru').split('-')[0]
  return AVAILABLE_LOCALES.includes(browserLocale) ? browserLocale : 'ru'
}

const russianPluralRule = choice => {
  const n = Math.abs(choice)
  const n10 = n % 10
  const n100 = n % 100
  if (n10 === 1 && n100 !== 11) return 0
  if (n10 >= 2 && n10 <= 4 && (n100 < 10 || n100 >= 20)) return 1
  return 2
}

export default createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, ru },
  pluralRules: {
    ru: russianPluralRule,
  },
})
